import React, { Component } from 'react';

import { Row, Col, Card } from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/InsuranceKnowledge/Approvals/Approvals.css";

import LawsInsideTwo from "./LawsInsideTwo.js";

const content = (
     <span>
          قانون تاسيس موسسات بيمه غير دولتي ماده واحده ـ به منظور تعميم و گسترش صنعت بيمه دركشور، افزايش رقابت و كارائي در بازار بيمه ، افزايش رفاه عمومي و گسترش امنيت اجتماعي و اقتصادي ، افزايش نقش بيمه دررشد و توسعه اقتصادي كشور و جلوگيري از ضرر وزيان جامعه با توجه به ذيل اصل چهل وچهارم (۴۴) قانون اساسي و درچارچوب ضوابط ، قلمرو وشرايط تعيين شده زير اجازه تاسيس موسسه بيمه غير دولتي به اشخاص داخلي داده ميشود :
          <br/>
          ۱. سياستگذاري در صنعت بيمه ، اعمال نظارت بر فعاليتهاي بيمه اي و صدور مجوز فعاليت بيمه اي كماكان جهت اعمال حاكميت در اختيار دولت جمهوري اسلامي ايران باقي خواهد بود.
          <br />
          ۲.ضوابط مربوط به نحوه تاسيس و فعاليت موسسات بيمه داخلي از قبيل شرايط اخذ مجوز تاسيس و لغو آن ، نحوه انتقال عمليات و ادغام ، انحلال و ورشكستگي موسسات بيمه اي ، محدوده فعاليت بيمه اي و بيمه اتكائي شامل انواع معاملات بيمه ، حق بيمه و كارمزد مربوط به رشته هاي مختلف بيمه ، ميزان ذخاير فني و اندوخته هاي قانوني و نحوه سرمايه گذاري آنها براساس قانون تاسيس بيمه مركزي ايران و بيمه گري مصوب ۳۰/۳/۱۳۵۰ و اصلاحيه بعدي و قانون بيمه مصوب ۷/۲/۱۳۱۶ً تعيين خواهد شد.
          <br />
          ۳. حداقل سرمايه موسسات بيمه موضوع ماده (۳۶) قانون تاسيس بيمه مركزي ايران و بيمه گري مصوب ۳۰/۳/۱۳۵۰براي موسسات بيمه غيردولتي با پيشنهادبيمه مركزي ايران و تائيد وزارت امور اقتصادي و دارائي و تصويب هيات وزيران تعيين خواهد شد
          <br />
          قانون فوق مشتمل بر ماده واحده در جلسه علني روز سه شنبه مورخ ششم شهريور ماه يكهزارو سيصد و هشتاد مجلس شوراي اسلامي تصويب و درتاريخ ۲۷/۶/۱۳۸۰ به تائيد شوراي نگهبان رسيده است .


     </span>
);
const SpecificThreeInside = props => {
     return props.size === "laptopdesktop" ? (
          <div>
               <LawsInsideTwo title="قانون تاسيس موسسات بيمه غير دولتی " text={content} size="laptopdesktop" />
          </div>
     ) : props.size === "tablet" ? (
          <div>
                    <LawsInsideTwo title="قانون تاسيس موسسات بيمه غير دولتی " text={content} size="tablet" />
          </div>

     ) : (
                    <div>
                         <LawsInsideTwo title="قانون تاسيس موسسات بيمه غير دولتی " text={content} />
                    </div>
               );
};

export default SpecificThreeInside;
